import { inventoryItemIdFormat } from "@redotech/redo-ims-id";
import { locationIdFormat } from "@redotech/redo-inventory-id";
import { productIdFormat } from "@redotech/redo-product-id";
import { storageLocationIdFormat } from "@redotech/redo-warehouse-id";
import * as z from "zod";

const LotBinSchema_ = z.object({
  storageLocationId: storageLocationIdFormat.schema,
  binName: z.string(),
  quantity: z.number().int(),
});
export const LotBinSchema: z.ZodType<LotBin> = LotBinSchema_;
export interface LotBin extends z.infer<typeof LotBinSchema_> {}

const LotRowSchema_ = z.object({
  id: inventoryItemIdFormat.schema,
  productId: productIdFormat.schema,
  productSku: z.string().nullable(),
  productTitle: z.string(),
  productImage: z.string().nullable(),
  lotNumber: z.string().nullable(),
  expirationDate: z.date().nullable(),
  onHand: z.number().int(),
  bins: z.array(LotBinSchema),
  createdAt: z.date(),
});
export const LotRowSchema: z.ZodType<LotRow> = LotRowSchema_;
export interface LotRow extends z.infer<typeof LotRowSchema_> {}

export const listLots = {
  name: "listLots" as const,
  input: z.object({
    locationId: locationIdFormat.schema.nullish(),
    productId: productIdFormat.schema.nullish(),
    includeSystemBins: z.boolean().optional(),
  }),
  output: z.object({ lots: z.array(LotRowSchema) }),
};

export const createLot = {
  name: "createLot" as const,
  input: z.object({
    locationId: locationIdFormat.schema,
    productId: productIdFormat.schema,
    lotNumber: z.string().min(1),
    expirationDate: z.date(),
  }),
  output: z.object({ id: inventoryItemIdFormat.schema }),
};

export const updateLot = {
  name: "updateLot" as const,
  input: z.object({
    id: inventoryItemIdFormat.schema,
    lotNumber: z.string().min(1).optional(),
    expirationDate: z.date().optional(),
  }),
  output: z.object({ id: inventoryItemIdFormat.schema }),
};
